export const CHAT_FEED_TEXT_AREA_TEST_ID = 'chat-feed-text-area-test-id';
export const CHAT_FEED_TEXT_AREA_ID = 'chat-feed-text-area-id';
